class DynamicWidthSelect extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupListeners()
    this.adjustSelectWidths()
  }

  setupListeners () {
    this.querySelectorAll('select').forEach(select => {
      // Modified listener for 'change' event to remove the class
      select.addEventListener('change', () => {
        this.adjustSelectWidth(select);
        // Remove the 'utl-Select_Open' class upon selection
        select.classList.remove('utl-Select_Open');
      });

      // 'focus' event listener to add the 'utl-Select_Open' class
      select.addEventListener('focus', () => {
        select.classList.add('utl-Select_Open');
      });

      // 'blur' event listener to remove the 'utl-Select_Open' class
      select.addEventListener('blur', () => {
        select.classList.remove('utl-Select_Open');
      });
    });
  }

  adjustSelectWidth (select) {
    // Create a temporary element to measure the text width
    const tempEl = document.createElement('span')
    tempEl.classList.add('prd-CardSimpleVariants_OptionTemp')
    tempEl.innerText = select.options[select.selectedIndex].text
    document.body.appendChild(tempEl)

    // Get the width of the text
    const textWidth = tempEl.getBoundingClientRect().width

    // Remove the temporary element
    document.body.removeChild(tempEl)

    const totalWidth = textWidth

    // Set the width of the select element
    select.style.width = `${totalWidth}px`
  }

  adjustSelectWidths () {
    this.querySelectorAll('select').forEach(select => {
      this.adjustSelectWidth(select)
    })
  }
}

if (!customElements.get('dynamic-width-select')) {
  customElements.define('dynamic-width-select', DynamicWidthSelect)
}
